import React from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';

export const COPY = defineMessages({
  CREATE_TEAM: {
    id: 'ButtonTeam.createTeam',
    defaultMessage: 'Create team',
    description:
      '[Type: Label][Vis.: high] - This is the create team addon button on the header.',
  },
});

const ButtonTeam = () => {
  return (
    <Button
      size="sm"
      color="upgrade"
      href={createURL('/billing/p2gupgrade/', {
        ut_source: 'header',
        ut_source3: 'webplat',
      })}
    >
      <T desc={COPY.CREATE_TEAM} />
    </Button>
  );
};

export default ButtonTeam;
